import React from 'react';
import './panels.css';

const SECTIONS = [
  { code: 'DM', label: 'Decision Making' },
  { code: 'VR', label: 'Verbal Reasoning' },
  { code: 'QR', label: 'Quantitative Reasoning' },
  { code: 'SJT', label: 'Situational Judgement' },
];

function QuestionBankPanel({ onSelect }) {
  return (
    <div className="panel">
      <h2>Question Bank</h2>
      <p className="panel-intro">
        Study individual questions from the question bank, with explanations and a difficulty rating on every question.
      </p>
      <div className="section-tile-grid">
        {SECTIONS.map((s) => (
          <button key={s.code} className="section-tile" onClick={() => onSelect(s.code)}>
            <div className="section-tile-code">{s.code}</div>
            <div className="section-tile-label">{s.label}</div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default QuestionBankPanel;
